import styled from 'styled-components'

export const Pill = styled.span`
  padding: 0.5rem 1rem;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.surface.background};
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.font.subdued};
`
